import type { Date as GraphQLDate } from '~/graphql/types';
import { format } from '~/util/date';

type ParsedDateTime = {
  date: string;
  time?: string;
};

/**
 * Parses GraphQL date object or string into formatted date and time
 *
 * @param date - GraphQL Date object or ISO string
 * @returns Object with formatted date string and optional time string
 */
const getDateAndTimeString = (date: GraphQLDate | string): ParsedDateTime => {
  if (typeof date === 'string') {
    return {
      date: format(new Date(date), 'dd-MM-yyyy'),
      time: undefined,
    };
  }

  // Parse GraphQL Date objects
  const formattedDate = format(new Date(date.d), 'dd-MM-yyyy');

  // Handle dates with specific time
  if (date.__typename === 'Date_DayTime' && date.t) {
    const [hours, minutes] = date.t.split(':');
    return {
      date: formattedDate,
      time: `${hours}:${minutes}`,
    };
  }

  // Handle day-only dates
  return {
    date: formattedDate,
    time: undefined,
  };
};

export default getDateAndTimeString;
